import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import type { Snippet as SnippetType } from '@/shared/api-generated-types'
import * as styles from './style'

export interface Props extends Partial<SnippetType> {}

const Snippet = ({ title, content, primaryAction, secondaryAction }: Props): JSX.Element => (
  <div className={styles.root}>
    <Layout>
      <Stack x alignItems="center">
        <Stack y className="pr-sm">
          {title && (
            <Text tag="h3" size="md" responsiveSize={{ sm: 'sm', lg: 'md' }} weight="md" className="mb-sm">
              {title}
            </Text>
          )}
          <Text tag="p" size="sm" responsiveSize={{ sm: 'xs', lg: 'sm' }} weight="sm">
            {content}
          </Text>
        </Stack>

        {!!primaryAction && (
          <Button label={primaryAction.label} theme="secondary" component="link" size="sm" href={primaryAction.url} />
        )}
        {!!secondaryAction && (
          <Button label={secondaryAction.label} theme="primary" component="link" size="sm" href={secondaryAction.url} />
        )}
      </Stack>
    </Layout>
  </div>
)

export default Snippet
